import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=108eb604&scoped=true"
import script from "./RouteView.vue?vue&type=script&lang=js"
export * from "./RouteView.vue?vue&type=script&lang=js"
import style0 from "./RouteView.vue?vue&type=style&index=0&id=108eb604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108eb604",
  null
  
)

export default component.exports